/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilebillingcity2Inputs */

const en_profilebillingcity2 = /** @type {(inputs: Profilebillingcity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

const de_profilebillingcity2 = /** @type {(inputs: Profilebillingcity2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Profilebillingcity2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilebillingcity2 = /** @type {((inputs?: Profilebillingcity2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilebillingcity2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilebillingcity2(inputs)
	return de_profilebillingcity2(inputs)
});
export { profilebillingcity2 as "profileBillingCity" }